export default __webpack_public_path__ + "static/argent@2x-5b83cf609582efdcaa1861ce07fa729f.png";